import s, { useState as h, useMemo as l, useEffect as g } from "react";
import { useAtom as u, useAtomValue as a } from "jotai";
import { CollapsibleContainer as E } from "./index94.mjs";
import S from "./index133.mjs";
import { getConfigPropertyAtomCreator as d, ConfigProperty as c } from "./index13.mjs";
import { totalAdultsAtom as b, totalChildrenAtom as x } from "./index26.mjs";
import G from "./index156.mjs";
import { GUESTS as _ } from "./index157.mjs";
import { getGuests as I } from "./index158.mjs";
import { GuestsStepper as N } from "./index159.mjs";
const X = ({ expand: t }) => {
  const [f, r] = h(!1), [m, p] = u(b), [i, e] = u(x), A = a(
    l(() => d(c.MAX_ADULTS), [])
  ), n = a(
    l(
      () => d(c.MAX_CHILDREN),
      []
    )
  ), o = n > "0";
  g(() => {
    t !== void 0 && r(t), o || e(0);
  }, [t, o, e]);
  const C = I({
    totalAdults: m,
    totalChildren: i,
    isChildrenAllowed: o,
    withDash: !0
  });
  return /* @__PURE__ */ s.createElement(
    E,
    {
      className: G[`${_}--content`],
      title: I18n.t("booking_engine.room.guests"),
      icon: /* @__PURE__ */ s.createElement(S, { "data-testid": "icon-guests" }),
      subtitle: C,
      expand: f,
      setExpand: r
    },
    /* @__PURE__ */ s.createElement(
      N,
      {
        setAmountAdults: p,
        setAmountChildren: e,
        limitAdults: Number(A),
        limitChildren: Number(n),
        amountAdults: m,
        amountChildren: i
      }
    )
  );
};
export {
  X as Guests
};
